// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__w5qC0","home__textOverflow":"styles_home__textOverflow__YI0WR"};